<template>
  <b-form-group label="Inscrição">
    <validation-provider
      #default="{ errors }"
      rules="required"
      name="'Inscrição'"
    >
      <b-input-group>
        <masked-input
          ref="cadastroFederal"
          v-model="value_"
          :class="{'is-invalid' : errors.length > 0}"
          :mask="mascaraCadFederal"
          class="form-control"
          @input="enviarParaPai"
        />
        <b-input-group-append>
          <b-button
            v-b-tooltip.hover
            :disabled="cnpjInvalido"
            title="Buscar dados da empresa"
            variant="primary"
            style="float:right"
            @click="buscarCNPJ()"
          >
            <feather-icon icon="SearchIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-row align-h="between">
        <b-col cols="auto">
          <span
            v-if="incricaoExiste"
            style="color: red; font-size: 12px;"
          > Inscrição duplicada! </span>
          <small class="text-danger">{{ errors[0] }}</small>
          <small
            v-if="errors.length == 0 && (!value_ || value_ === '') && msgErro"
            class="text-danger"
          >
            O campo 'Inscrição' é obrigatório
          </small>
        </b-col>
      </b-row>
    </validation-provider>
  </b-form-group>
</template>

<style>

.text-rfb {
  font-size: 0.8rem;
  height: 19px;
  padding: 0;
  color: blue !important;
  background-color: transparent !important;
  border-color: transparent !important;
  padding-left: 1rem;
}

</style>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '../../services/api'

export default {
  name: 'EmpresaCNPJInput',
  components: {
    ValidationProvider,
  },
  props: {
    required,
    value: {
      type: String,
      default: '',
    },
    incricaoExist: {
      type: Boolean,
      default: false,
    },
    msgErro: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cnpj: '',
      incricaoExiste: this.incricaoExist,
    }
  },
  computed: {
    value_: {
      get() {
        return this.cnpj ? this.cnpj : this.value
      },
      set(newValue) {
        this.cnpj = newValue
        return this.cnpj
      },
    },
    cnpjInvalido: {
      get() {
        return !(this.value_ ? this.value_.replace(/\D/g, '').length === 14 : false)
      },
    },
  },
  watch: {
    value(val, oldValue) {
      if (val !== oldValue) {
        this.cnpj = val
      }
    },
    incricaoExist(value, oldValue) {
      if (value !== oldValue) {
        this.incricaoExiste = value
      }
    },

  },
  methods: {
    buscarCNPJ() {
      if (!this.cnpjInvalido) {
        this.$isLoading(true)
        api.getInformacaoEmpresa(this.value_)
          .then(payload => {
            const empresa = payload.data
            empresa.incricaoExist = this.incricaoExiste
            this.$emit('dados-navegacao', empresa)
            this.$isLoading(false)
          })
          .catch(err => {
            this.$isLoading(false)
            this.$toast({
              component: ToastificationContent,
              props: {
                // title: 'Não foi possível cadastrar as informações',
                title: err.message || err.response.data.message, //  err.message || err.response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          })
      }
    },
    mascaraCadFederal() {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    /* eslint no-underscore-dangle: 0 */
    enviarParaPai() {
      this.$emit('input', this.value_)
    },
  },
}
</script>
